// TONA: search for entered keywords instead of semantically related motifs.
window.TonaKeywordSearch = {
  query(value) {
    const text = value.trim();
    // Preserve deliberately entered Shopify search syntax.
    if (!text || /[:"()]/.test(text) || /\b(?:AND|OR|NOT)\b/.test(text)) return text;
    const terms = text.match(/[\p{L}\p{N}_-]+/gu);
    if (!terms) return text;
    return terms.map(term => `(title:${term}* OR tag:${term}* OR body:${term}* OR variants.sku:${term}*)`).join(' AND ');
  },
  display(value) {
    const terms = [...value.matchAll(/\(title:([^*\s]+)\* OR tag:\1\* OR body:\1\* OR variants\.sku:\1\*\)/g)].map(match => match[1]);
    const text = terms.join(' ');
    return terms.length && this.query(text) === value ? text : value;
  },
  restoreText(root, query, display) {
    if (!root || !query || query === display) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement?.closest('script, style') && node.nodeValue.includes(query)) {
        node.nodeValue = node.nodeValue.split(query).join(display);
      }
    }
    root.querySelectorAll('[aria-label]').forEach(element => {
      const label = element.getAttribute('aria-label');
      if (label.includes(query)) element.setAttribute('aria-label', label.split(query).join(display));
    });
  }
};

function restoreTonaSearchTerms() {
  const query = new URLSearchParams(window.location.search).get('q');
  if (!query) return;
  const display = window.TonaKeywordSearch.display(query);
  window.TonaKeywordSearch.restoreText(document.querySelector('main'), query, display);
  document.title = document.title.split(query).join(display);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreTonaSearchTerms);
else restoreTonaSearchTerms();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.value = window.TonaKeywordSearch.display(this.input.value);
      this.input.form.addEventListener('formdata', (event) => {
        event.formData.set('q', window.TonaKeywordSearch.query(this.input.value));
      });
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
